module.exports = __webpack_public_path__ + "img/tolaat_yes.1529433e.png";